import React, { useState, useContext } from "react";
import {
  AiFillHome,
  AiOutlineMenu,
  AiOutlineSearch,
  AiOutlineClose,
} from "react-icons/ai";
import { FaFire, FaShoppingCart } from "react-icons/fa";
import { MdOutlineRestaurantMenu, MdCategory } from "react-icons/md";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import tastylogo from "../assets/tastylogo.png";
import { FaCartShopping } from "react-icons/fa6";

function Navbar() {
  const [nav, setNav] = useState(false);
  const [items, setItems] = useState([]);
  const [searchItem, setSearchItem] = useState("");
  const navigate = useNavigate();
  const [borderFocus, setBorderFocus] = useState("home");

  const handleClick = (focus) => {
    setNav(!nav);
    switchFocus(focus)
  };

  const switchFocus = (tab) => {
    if (tab == "home") {
      setBorderFocus("home");
    }
    if (tab == "orders") {
      setBorderFocus("orders");
    }
    if (tab == "customers") {
      setBorderFocus("customers");
    }
  };

  return (
    <div className="fixed mx-auto p-3 lg:p-3 bg-gray-50 top-0 left-0 right-0 z-10">
      <div className="px-1 lg:px-2">
        <header className="flex flex-col gap-1 lg:flex lg:justify-between lg:flex-row">
          {/* Logo Container */}
          <div className="flex gap-2 lg:gap-10 items-center">
            {/* Hamburger Menu */}
            <div
              onClick={() => setNav(!nav)}
              className="cursor-pointer lg:hidden"
            >
              <AiOutlineMenu
                size={30}
                className="text-black hover:shadow-wine-500 hover:shadow-sm duration-100"
              />
            </div>
            {/*  Logo */}
            <Link
              to="/"
              className="flex justify-between items-center gap-1 cursor-pointer border rounded-md bg-gray-600 px-3 py-1 lg:py-2"
            >
              <FaFire
                size={30}
                className="text-white rounded-full bg-gradient-to-r  from-orange-400 to-red-400"
              />

              <h2 className="text-lg lg:text-2xl   text-gray-50 font-[Gorditas]">
                FireDashboard
              </h2>
            </Link>
            <div class="relative mt-1 lg:w-80 hidden lg:block">
              <div class="flex absolute inset-y-0 left-0 items-center pl-3 pointer-events-none">
                <svg
                  class="w-5 h-5 text-gray-500"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z"
                    clip-rule="evenodd"
                  ></path>
                </svg>
              </div>
              <input
                type="text"
                name="search"
                id=""
                class="bg-gray-50 border hidden lg:block border-gray-300 text-gray-900 sm:text-sm rounded-lg 
focus:outline-none placeholder:text-slate-400 focus:ring-2 ring-orange-200 focus:ring-orange-300 ring-1 block w-full pl-10 p-2.5"
                placeholder="Search"
              />
            </div>
          </div>
          {/* Search & Cart Container */}
          <div className="flex gap-2 pt-1">
            {/* Search Icon and input */}
            <button
              type="button"
              data-dropdown-toggle="notification-dropdown"
              class="p-2 text-gray-500 rounded-2xl hover:text-gray-900 hover:bg-gray-100"
            >
              <span class="sr-only">View notifications</span>
              <svg
                class="w-6 h-6"
                fill="currentColor"
                viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M10 2a6 6 0 00-6 6v3.586l-.707.707A1 1 0 004 14h12a1 1 0 00.707-1.707L16 11.586V8a6 6 0 00-6-6zM10 18a3 3 0 01-3-3h6a3 3 0 01-3 3z"></path>
              </svg>
            </button>{" "}
            <button
              type="button"
              data-dropdown-toggle="apps-dropdown"
              class="p-2 text-gray-500 rounded-2xl hover:text-gray-900 hover:bg-gray-100"
            >
              <span class="sr-only">View notifications</span>
              <svg
                class="w-6 h-6"
                fill="currentColor"
                viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M5 3a2 2 0 00-2 2v2a2 2 0 002 2h2a2 2 0 002-2V5a2 2 0 00-2-2H5zM5 11a2 2 0 00-2 2v2a2 2 0 002 2h2a2 2 0 002-2v-2a2 2 0 00-2-2H5zM11 5a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V5zM11 13a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z"></path>
              </svg>
            </button>
            <button
              type="button"
              class="text-sm bg-gray-50 px-[1px] py-[2px] rounded-full"
              id="user-menu-button-2"
              aria-expanded="false"
            >
              <span class="sr-only">Open menu</span>
              <img
                class="w-8 h-8 rounded-full"
                src="https://www.uchay.com/_next/image?url=%2F_next%2Fstatic%2Fmedia%2Favatar.e221eedc.jpg&w=1920&q=75"
                alt="user photo"
              />
            </button>
            {/* Cart container */}
            <Link
              to="/checkout"
              target="_blank"
              className="hidden lg:flex bg-orange-500 hover:scale-[1.02] transition-transform text-white px-4 py-1 rounded-full hover:shadow-lg flex flex-row font-medium justify-center items-center gap-3 cursor-pointer"
            >
              <FaCartShopping class=""></FaCartShopping>
            </Link>
          </div>
        </header>
        {/* Overlay */}
        {nav ? (
          <div className="bg-black/80 absolute w-full h-screen z-10 top-0 left-0"></div>
        ) : (
          ""
        )}
        <aside
          className={`${
            nav ? "block top-0" : "hidden"
          }  lg:block fixed  left-0 w-[220px] h-screen bg-gray-50 z-30 duration-300 text-gray-500 overflow-auto`}
        >
          {nav && (
            <div>
              <AiOutlineClose
                onClick={() => setNav(!nav)}
                size={30}
                className="absolute right-4 top-4 cursor-pointer "
              />
              <div className="flex  items-center flex-row p-5 gap-1">
                <FaFire
                  size={30}
                  className="text-white rounded-full bg-gradient-to-r  from-orange-400 to-red-400"
                />
                <img
                  src={tastylogo}
                  style={{ marginTop: "10px", width: "50px", height: "auto" }}
                  alt="Tastyy Logo"
                />
              </div>
            </div>
          )}
          <nav>
            <ul className="flex flex-col p-4 py-6">
              <Link to="/">
                <li
                  onClick={() => nav ? handleClick("home"): switchFocus("home")}
                  className={`text-xl py-4 px-5 flex cursor-pointer ${
                    borderFocus === "home" ? "border-b border-b-orange-500" : ""
                  }  hover:bg-white`}
                >
                  {" "}
                  <div className="flex justify-between items-center ">
                    <AiFillHome size={25} className="mr-4 " /> Home
                  </div>
                </li>
              </Link>
              <Link to="/customers">
                <li
                  onClick={() => nav ? handleClick("customers"): switchFocus("customers")}
                  className={`text-xl py-4 px-5 flex cursor-pointer ${
                    borderFocus === "customers"
                      ? "border-b border-b-orange-500"
                      : ""
                  }  hover:bg-white`}
                >
                  <div className="flex justify-between items-center ">
                    <i>
                      <MdOutlineRestaurantMenu size={25} className="mr-4" />{" "}
                    </i>
                    Customers
                  </div>
                </li>
              </Link>
              <Link to="/orders">
                <li
                  onClick={() => nav ? handleClick("orders"): switchFocus("orders")}
                  className={`text-xl py-4 px-5 flex cursor-pointer ${
                    borderFocus === "orders"
                      ? "border-b border-b-orange-500"
                      : ""
                  }  hover:bg-white`}
                >
                  <div className="flex justify-between items-center ">
                    <MdCategory size={25} className="mr-4" /> Orders
                  </div>
                </li>
              </Link>
            </ul>
          </nav>
        </aside>
      </div>
    </div>
  );
}

export default Navbar;
